import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var GiftFilledSvg = function GiftFilledSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.15 4.11a1.92 1.92 0 0 0-1.344.545A1.84 1.84 0 0 0 7.25 5.97h-1.9c0-.756.235-1.494.674-2.115a3.8 3.8 0 0 1 1.782-1.366 3.88 3.88 0 0 1 2.26-.13c.749.182 1.423.583 1.934 1.15a3.8 3.8 0 0 1 1.934-1.15 3.88 3.88 0 0 1 2.26.13 3.8 3.8 0 0 1 1.782 1.366c.439.621.674 1.36.674 2.115h-1.9c0-.493-.2-.966-.556-1.315a1.92 1.92 0 0 0-1.344-.545 1.92 1.92 0 0 0-1.343.545 1.84 1.84 0 0 0-.557 1.315h-1.9c0-.493-.2-.966-.557-1.315A1.92 1.92 0 0 0 9.15 4.11M21.5 7.365h-19v5.582h19zM3.45 14.342v7.907h7.837v-7.907zm9.263 0v7.907h7.837v-7.907z",
    clipRule: "evenodd"
  }));
};
export var GiftFilled = function GiftFilled(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: GiftFilledSvg
  }));
};